import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SegmentoMercadoGraficoComponent } from './segmento-mercado-grafico.component';
import { CabecalhoDireitaModule } from '../../components/cabecalho/cabecalho-direita/cabecalho-direita.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';
import { ExemplosModule } from '../../components/exemplos/exemplos.module';

@NgModule({
  declarations: [
    SegmentoMercadoGraficoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoDireitaModule,
    SolucoesModule,
    ExemplosModule
  ],
  exports: [
    SegmentoMercadoGraficoComponent
  ]
})

export class SegmentoMercadoGraficoModule { }
